import { render } from "./EditPurchaseReturnPage.vue?vue&type=template&id=3d85621c&ts=true"
import script from "./EditPurchaseReturnPage.vue?vue&type=script&lang=ts"
export * from "./EditPurchaseReturnPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__